import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function LessZoomIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "8"}
      height={height || "8"}
      viewBox="0 0 8 8"
    >
      <path
        id="Caminho_10305"
        data-name="Caminho 10305"
        d="M8.682,10.4h3.636l.655,1.6H14.5L11.045,4H9.955L6.5,12H8.027ZM10.5,5.44l1.36,3.651H9.14Z"
        transform="translate(-6.5 -4)"
        fill={color || "#555"}
      />
    </svg>
  );
}
